<template>
  <div class="page_top page_bg">
    <div class="page_text_protocol hd1_main">
      <div class="hd1_title">
        <img src="@/assets/huodong_dot.png" alt="">
        <span class="ml_05">精彩活动</span>
      </div>
      <div class="hd1_name">
        【公告声明】无悠网络关于规范游戏市场的声明
      </div>
      <div class="hd1_time">
        2019-09-27 15:36:04
      </div>
      <div class="hd1_text">
        尊敬的无悠网络玩家：
        根据网络游戏行业监管部门的要求，进一步净化网络游戏环境、规范网络游戏市场，为了全面遏制、打击不法分子利用无悠网络平台从事违法活动，无悠网络特此声明：
        一、无悠网络每局游戏结束后的结算积分，仅是每盘游戏对局的分数记录，在每盘结束后积分清零，不具备任何货币属性，不可流通，也不具有任何交易价值。
        二、游戏中使用的房卡，仅能开设房间使用，不具备任何货币价值，没有任何其他用途；
        三、无悠网络严禁玩家之间出现任何赌博行为，对玩家所拥有的积分、房卡不提供任何形式的回购、直接或间接兑换现金、实物等服务功能。
        四、无悠网络设置专门客服功能，接受广大玩家的监督举报，一旦发现涉嫌赌博等违规违法行为，我司将立即封停账号等处理措施，对于情节严重者将向公安机关举报。
        五、无悠网络严禁未成年人沉迷游戏的行为，请成年玩家合理安排娱乐时间，健康游戏。
        六、请勿相信任何非无悠网络官方渠道发布的信息，避免造成您财产损失。
        为了共同营造一个健康、绿色的娱乐环境，需要各位玩家的积极支持与配合，请各位玩家文明游戏、远离赌博等违法违规行为！      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HuoDong1Mobile',
  components: {
  },
  data: () => {
    return {
    }
  },
  mounted () {
    this.onToTop()
  },
  methods: {
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  },
  computed: {

  }
}
</script>
<style scoped>
.hd1_main {
  background: rgb(246, 247, 251);
  text-align: left;
}
.hd1_title {
  font-size: 1rem;
  border-bottom: 1px rgba(0, 0, 0, 0.06) solid;
  padding: 0.3rem 1rem;
}
.hd1_text {
  padding: 1rem;
  text-indent: 1.6rem;
  font-size: 0.6rem;
  padding-bottom: 2rem;
}
.hd1_name {
  text-align: center;
  font-size: 1rem;
  font-weight: bold;
  margin-top: 1rem;
}
.hd1_time {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  margin-top: 1rem;
}
</style>
